var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{directives:[{name:"disable-number-scroll",rawName:"v-disable-number-scroll"}],attrs:{"outlined":"","dense":"","type":"number","label":_vm.$t('common.answer'),"value":_vm.response,"disabled":_vm.loading,"rules":_vm.rules},on:{"input":function($event){return _vm.$emit('change', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }